import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const StyledButton = styled(Button)`
  margin: auto 0;
  &&& {
    border: none;
    background: none;
    box-shadow: none;
    color: var(--text-color-secondary);
    padding: 0;
    height: auto;

    &:hover {
      background: none;
      box-shadow: none;
      color: var(--text-color-primary);
    }
  }
`;

const CloseText = styled.span`
  color: #fff;
  cursor: pointer;
  font-weight: 500;
  position: absolute;
  right: 20px;
  top: -13px;
  background: var(--sumi-blue);
  font-size: 15px;
  padding: 2px 5px;
  border-radius: 6px;
`;

interface InfoButtonProps {
  infoText: string;
}

export const InfoButton: React.FC<InfoButtonProps> = ({ infoText }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  const handleOpen = () => setVisible(true);
  const handleClose = () => setVisible(false);

  const dialogHeader = (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <CloseText
        onClick={handleClose}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleClose();
        }}
      >
        {t("cmd-close")}
      </CloseText>
    </div>
  );

  return (
    <>
      <StyledButton
        unstyled
        icon="pi pi-info-circle"
        className="info-button p-button-text p-button-rounded"
        aria-label="Show info"
        onClick={handleOpen}
      />
      <Dialog
        header={dialogHeader}
        visible={visible}
        onHide={handleClose}
        closable={false}
        style={{ maxWidth: "400px" }}
        closeOnEscape
      >
        <div style={{ padding: "1rem" }}>{infoText}</div>
      </Dialog>
    </>
  );
};
